import { useEffect } from "react";
import { Paper, Grid, Typography, TextField } from "@mui/material";
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import { useSnackbar } from "notistack";
import { useProjectStore } from "../model/ProjectStore";
import { NumericFormat } from "react-number-format";

const styles = (theme) => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  details: {
    flexDirection: "column",
  },
});

const SummaryView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const project = useProjectStore();

  useEffect(() => {
    project.checkProjUpdate(project.id, project.currentHash, enqueueSnackbar)
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
        if (error.cause === "opaqueredirect") {
          setTimeout(() => {
            window.location.href = "/login";
          }, 1000);
        }
      });
  }, [enqueueSnackbar, project]);
  return (
     <Paper
      style={{
        minWidth: "1280px",
        minHeight: "400px",
        padding: "8px"
      }}
    >
      
      {project.name}
      <Typography color="textPrimary" variant="h6">
        Project Configuration
      </Typography>
      <Grid>
          <TextField
            key={project.id + "_dataPeriod"}
            id="data-period"
            label="Data Period"
            value={project.dataPeriod}
            onChange={(e) => (runInAction(() => { project.dataPeriod = e.target.value }))}
            variant="outlined"
          />
        </Grid>
    </Paper>
  );
};

export default observer(SummaryView);
